// extracted by mini-css-extract-plugin
module.exports = {"container":"BroadcastReference_container__3Jd8p"};